import {Text} from 'src/design/atoms/Text';
import React from 'react';
import type {PersonnelImportCounts} from 'src/api/ProactApiClient';
import {InfoAlert} from 'src/design/molecules/InfoAlert';

export interface ReceiptStepProps {
  counts: PersonnelImportCounts;
  email?: string;
}

const buildBreakdown = (
  createCount: number,
  updateCount: number,
  deactivateCount: number
) =>
  [
    createCount > 0 ? `${createCount} to create` : null,
    updateCount > 0 ? `${updateCount} to update` : null,
    deactivateCount > 0 ? `${deactivateCount} to deactivate` : null,
  ]
    .filter(Boolean)
    .join(', ');

export const ReceiptStep: React.FC<ReceiptStepProps> = ({counts, email}) => {
  const {
    create: createCount,
    update: updateCount,
    deactivate: deactivateCount,
    reject: rejectedCount,
  } = counts;
  const queuedCount = createCount + updateCount + deactivateCount;
  const breakdown = buildBreakdown(createCount, updateCount, deactivateCount);

  return (
    <InfoAlert title="Import started" variant="success">
      <Text size="sm">
        {queuedCount} {queuedCount === 1 ? 'row is' : 'rows are'} queued
        {breakdown ? `: ${breakdown}.` : '.'}
        {email
          ? ` You will receive an email at ${email} when it finishes.`
          : ' You will receive an email when it finishes.'}
      </Text>
      {deactivateCount > 0 && (
        <Text size="sm" mt="xs">
          Deactivations take effect when the job finishes, not immediately.
        </Text>
      )}
      {rejectedCount > 0 && (
        <Text size="sm" mt="xs">
          {rejectedCount} {rejectedCount === 1 ? 'row was' : 'rows were'}{' '}
          rejected and will not be imported. The email lists each rejected row
          and its reason.
        </Text>
      )}
    </InfoAlert>
  );
};
